import React from 'react'
import ReactOwlCarousel from 'react-owl-carousel';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import {BsArrowRight} from 'react-icons/bs';
import { isMobile, isMobileOnly } from 'react-device-detect';
import { ImageUrl } from '../../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";

const BannerSlider = () => {
    const [sliders, setSliders] = useState([
        {img: `${ImageUrl}theme/newyork/Slider/slider-100.png`, mobimg: `${ImageUrl}theme/newyork/Slider/slider-100-mobile.png`, title: 'Engagement Rings', content: 'Discover our unique Engagement Rings collection', link: '/jewelry/engagement-rings', btnName: 'Shop Engagement Rings', class: 'text-center'},
        // {img: `${ImageUrl}theme/newyork/Slider/slider-2.png`, title: 'Perfect Symbol of Love', content: 'Explore the latest Wedding collection', link: '/jewelry/wedding-rings', btnName: 'Shop Wedding Rings', class: ''},
        // {img: `${ImageUrl}theme/newyork/Slider/slider-3.png`, title: 'Fine Jewelry', content: 'Explore the latest Fine Jewelry', link: '/jewelry/fine-jewelry', btnName: 'Shop Fine Jewelry', class: 'right-0'}
    ]);
    


    return (
        <div className='banner-slider'>
            <ReactOwlCarousel navText={["", '<BsArrowRight/>']} className="owl-main owl-theme" nav responsive={
                {
                    0: {
                        nav: false,
                    },

                    768: {
                        nav: true
                    }
                }
            } items={1} loop>
                {
                    sliders.map((slide, i) => <div key={i} className='item'>
                        {isMobileOnly ? <LazyLoadImage src={slide.mobimg} alt='' /> : <LazyLoadImage src={slide.img} alt='' />}
                        

                        <div className={'content ' + slide.class}> 
                            <h2>{slide.title}</h2>
                            <p className='m-0'>{slide.content}</p>
                            <Link className='btn solid-black' to={slide.link}>{slide.btnName}</Link>
                        </div>
                    </div>)
                } 
            </ReactOwlCarousel>    

            
        </div>
    )
}

export default BannerSlider;